import React from 'react';
import { AddClassificationDialog } from './AddClassificationDialog/AddClassificationDialog';
import { AddPayCodeDialog } from './AddPayCodeDialog/AddPayCodeDialog';
import { CreateCostCodeDialog } from './CreateCostCodeDialog/CreateCostCodeDialog';
import { CreateJobDialog } from './CreateJobDialog/CreateJobDialog';
import { ScopeInfoDialog } from './ScopeInfoDialog';

/** @registry Renders every global (DialogsProvider-driven) dialog for the app shell. */
export const Dialogs: React.FC = () => {
  return (
    <div>
      <CreateJobDialog />
      <ScopeInfoDialog />
      <CreateCostCodeDialog />
      <AddPayCodeDialog />
      <AddClassificationDialog />
    </div>
  );
};
